export default __webpack_public_path__ + "static/media/image-halfSkeleton-2000x3000-png.3d7c6b79.png";